import { render, staticRenderFns } from "./ApplicationsTab.vue?vue&type=template&id=4f230330"
import script from "./ApplicationsTab.ts?vue&type=script&lang=ts&external"
export * from "./ApplicationsTab.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports